/**
 * @generated SignedSource<<0d66fd68fdda568ac801a8e3fcf166be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditorialModuleArticles_articles$data = ReadonlyArray<{
  readonly publishedDate: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"ArticleLink_article">;
  readonly " $fragmentType": "EditorialModuleArticles_articles";
}>;
export type EditorialModuleArticles_articles$key = ReadonlyArray<{
  readonly " $data"?: EditorialModuleArticles_articles$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorialModuleArticles_articles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "EditorialModuleArticles_articles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArticleLink_article"
    }
  ],
  "type": "WordpressArticleType",
  "abstractKey": null
};

(node as any).hash = "96bfd98de68093c50d629ac7c3bb275b";

export default node;
